<template>
  <div class="product-page-header-skeleton__breadcrumbs">
    <SBreadcrumbsSkeleton />
  </div>
  <div class="product-page-header-skeleton">
    <div class="product-page-header-skeleton__content">
      <div class="product-page-header-skeleton__text">
        <SHeadingSkeleton size="1" width="70%" />
        <STextSkeleton font-size="lg" :lines="3" />
      </div>
      <PSkeleton class="product-page-header-skeleton__image" height="100%" />
      <ContentCtaFormSkeleton
        class="product-page-header-skeleton__form"
        heading
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  PSkeleton,
  SBreadcrumbsSkeleton,
  SHeadingSkeleton,
  STextSkeleton,
} from "@solvari/components";

import ContentCtaFormSkeleton from "~/shared/components/content-blocks/ContentCtaFormSkeleton.vue";
</script>

<style lang="postcss">
.product-page-header-skeleton {
  &__breadcrumbs {
    @apply flex w-full items-center py-4;
  }

  &__content {
    @apply mt-8 flex flex-col gap-8;

    @screen 700 {
      @apply grid gap-x-12 gap-y-8;
      grid-template-columns: 1fr auto;
      grid-template-areas:
        "text image"
        "form form";
    }

    @screen 1300 {
      @apply items-center;
      grid-template-areas:
        "text image"
        "form image";
    }
  }

  &__text {
    @apply flex flex-col;

    @screen 700 {
      grid-area: text;
    }
  }

  &__image {
    @apply hidden aspect-square rounded-xl;

    @screen 700 {
      @apply block !w-52;
      grid-area: image;
    }

    @screen 900 {
      @apply !w-64;
    }

    @screen 1000 {
      @apply !w-72;
    }

    @screen 1100 {
      @apply !w-80;
    }

    @screen 1200 {
      @apply !w-96;
    }
  }

  &__form {
    @screen 700 {
      grid-area: form;
    }
  }
}
</style>
